import React from 'react';
import PropTypes from 'prop-types';
import FlowChain from '../RefundWorkflow';
import FlowContainer from '../../../flow/FlowContainer';

class RefundView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: FlowChain(props.requestedState),
    };
  }

  render() {
    const { view, } = this.state;
    return (
      <div className="container">
        <FlowContainer chain={view} />
      </div>
    );
  }
}

RefundView.defaultProps = {
  requestedState: null,
};
RefundView.propTypes = {
  requestedState: PropTypes.object,
};

export default RefundView;
